var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-1 px-2"},[(
      _vm.isScheduledTimeWithinShortTime() || _vm.isScheduledTimeWithinVeryShortTime()
    )?_c('p',{staticClass:"board__card-timer caption mb-0",style:({
      color: _vm.textColor,
    })},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }